var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160,
    viewBox: "0 0 200 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r2f9af53ga",
    d: "M0.065 0.037L33.356 0.037 33.356 35.196 0.065 35.196z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xbp9m1ih3c",
    d: "M0 116.281L160.957 116.281 160.957 0.09 0 0.09z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H200V160H0z",
    transform: "translate(-1794 -140) translate(32 22) translate(1762 118)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.443,
    transform: "translate(-1794 -140) translate(32 22) translate(1762 118) translate(23 28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ACC7EB",
    d: "M74.382 116.28h-.075c-.615-.012-1.09-.514-1.032-1.093l4.102-40.964 3.579.32-5.89 41.184c-.046.322-.34.56-.684.554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8DBF4",
    d: "M113.878 116.28h.076c.614-.012 1.09-.514 1.031-1.093l-4.101-40.964-3.58.32 5.89 41.184c.046.322.34.56.684.554"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD4F4",
    d: "M45.444 116.28h-.075c-.615-.012-1.09-.514-1.032-1.093l4.102-40.964 3.58.32-5.89 41.184c-.047.322-.34.56-.685.554M112.657 68.264l7.28-35.956c.935-4.868-3.099-9.32-8.336-9.2l-14.042.321c-4.844.11-9.056 3.353-10.402 8.007L76.504 68.264h36.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC7EB",
    d: "M108.252 68.264l7.281-35.956c.934-4.868-3.1-9.32-8.337-9.2l-14.042.321c-4.844.11-9.056 3.353-10.402 8.007L72.099 68.264h36.153z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8DBF4",
    d: "M110.628 74.822H55.072c-1.116 0-2.03-.914-2.03-2.03v-2.499c0-1.116.914-2.03 2.03-2.03h57.585v4.53c0 1.115-.913 2.029-2.03 2.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACC7EB",
    d: "M84.557 74.822H49.142c-.9 0-1.635-.736-1.635-1.635v-3.288c0-.9.736-1.635 1.635-1.635h35.415c.899 0 1.635.735 1.635 1.635v3.288c0 .899-.736 1.635-1.635 1.635"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.637 .053)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y29rhqqfub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r2f9af53ga"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M9.313 34.184c-.783-.64 16.277-15.043 19.936-6.968 0 0 8.76-6.75.693-10.7-4.541-2.225-5.193-6.904-6.27-9.658-1.077-2.755-6.52-10.265-12.805-4.986 0 0-3.19.566-4.908 2.665C2.052 9.31-6.633 41.235 9.313 34.184",
    mask: "url(#y29rhqqfub)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E5925A",
    d: "M73.979 28.793s-2.967 5.334-7.126 9.76c-2.197 2.338-4.727 4.423-7.328 5.332-1.27.443-2.555.607-3.827.384-.812-.141-.46-4.934.669-8.578 1.486-4.798 6.118-16.722 6.118-16.722l2.65 1.13s-3.676 15.018-3.238 15.081l3.887-9.837 8.195 3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED7D2B",
    d: "M79.642 53.125s-29.538-.47-33.479 2.037c-3.94 2.507 3.94 42.531 3.94 42.531s7.64.244 8.247-1.778c0 0-1.375-18.755-.172-21.994 1.202-3.24.46-7.73.46-7.73s14.942 2.28 19.688 1.158c4.745-1.122 1.316-14.224 1.316-14.224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M51.72 95.658s1.681 4.502 1.324 6.172.22 4.907-.464 6.354-1.904 3.552-.733 4.084c.445.203 5.617-3.81 5.913-4.993.297-1.184.527-4.677 1.518-6.573.99-1.896.16-3.425-1.271-4.122-1.431-.698-3.425-4.516-3.425-4.516l-2.862 3.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4E96",
    d: "M46.703 102.643s-1.62 4.524-2.97 5.57c-1.35 1.045-2.998 3.89-4.454 4.555-1.457.665-3.746 1.485-3.195 2.648.209.44 6.75.713 7.74 0 .99-.713 3.42-3.233 5.4-4.043 1.98-.81 2.331-2.514 1.688-3.97-.643-1.456.297-5.66.297-5.66l-4.506.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M96.391 52.074S61.34 57.559 58.64 60.678c-2.7 3.119-13.397 43.746-13.397 43.746s3.121 1.751 5.967.13c0 0 8.143-13.769 11.74-18.088 3.598-4.32 4.978-17.684 5.57-17.82.593-.135 19.456 2.279 26.405-2.32 4.095-2.71 1.467-14.252 1.467-14.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M84.287 22.87c-2.069-1.556-8.294-3.276-12.188-1.524-1.843.83-4.64 1.917-6.315 3.997-1.807 2.245-3.887 9.837-3.887 9.837.68 4 3.86 4.489 3.86 4.489-1.862 7.04 6.91 5.2 6.342 9.104-.988 6.812 5.384 10.39 8.857 11.977 4.545 2.078 17.319 4.697 17.333 0 .062-21.395-8.055-33.402-14.002-37.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF3FA",
    d: "M83.58 30.46s-2.304 12.434-8.544 16.085h-5.872l6.199-7.749 8.217-8.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5925A",
    d: "M62.693 20.227s-1.907-2.272-2.242-2.96c-.334-.688.292-3.652 1.07-3.633.49.013 1.093 1.808 1.63 2.46.536.653 2.869 1.581 1.882 4.324-.111.31-2.34-.191-2.34-.191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB27D",
    d: "M67.542 24.77c-.538.807.118 3.069 3.168 2.364 2.002-.462 5.903-3.71 5.2-5.367-.335-.787-2.255-2.636-3.461-7.445l-.35.167-5.871 2.8s.636 1.91 1.108 3.742c.396 1.538.428 3.404.206 3.738"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A269",
    d: "M66.228 17.288s.636 1.91 1.108 3.743c3.435-.98 4.46-4.602 4.763-6.542l-5.871 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB27D",
    d: "M62.885 18.34s8.23 1.91 9.341-3.235c1.11-5.143 2.92-8.361-2.288-9.798-5.208-1.437-6.656.305-7.444 1.932-.788 1.627-1.721 10.472.391 11.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M66.203 4.373s.052 5.92 4.412 8.793c2.55 1.682 2.67 3.402 2.67 3.402s1.51-5.065 1.75-8.876c0 0-6.509-5.826-8.832-3.319"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#163560",
    d: "M66.721 5.419s-2.432.809-3.515 1.705c-1.602 1.326-2.02 5.64-1.829 6.713 0 0-.437-7.496 1.977-9.406 2.558-2.026 3.367.988 3.367.988"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB27D",
    d: "M83.58 30.461c-.838 1.998-1.807 3.876-2.835 5.577-3.928 6.494-8.73 10.418-10.466 8.59-.48-.507-1.69-1.242-.424-3.96.977-2.101 2.189-4.728 3.377-7.314 2.45-5.33 4.8-10.484 4.8-10.484.747 0 8.616.274 5.548 7.591"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB27D",
    d: "M75.363 38.796c-.27-.16-15.079 3.436-19.665 4.555l-1.34.328v1.728s15.324.72 17.717-.38c2.393-1.1 4.678-3.657 4.678-3.657l-1.39-2.574z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M83.58 30.461c-.838 1.998-1.807 3.876-2.835 5.577-3.2-.415-6.154-1.91-7.513-2.684 2.45-5.33 4.8-10.484 4.8-10.484.747 0 8.616.274 5.548 7.591"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED7D2B",
    d: "M27.417 45.41h16.45c0-.725-.586-1.312-1.31-1.312h-15.14v1.311z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED7D2B",
    d: "M27.465 27.493L2.031 27.493 8.132 45.409 33.73 45.409z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M1.657 27.493L7.757 45.409 33.356 45.409 27.09 27.493z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.369 36.286c.158.684.841 1.24 1.526 1.24.684 0 1.11-.556.953-1.24-.158-.685-.841-1.24-1.526-1.24-.684 0-1.111.555-.953 1.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ABFE2",
    d: "M122.381 74.775v1.042c0 .365.118.663.262.663h38.051c.144 0 .263-.298.263-.663v-1.042c0-.365-.119-.664-.263-.664h-38.05c-.145 0-.263.3-.263.664"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BAD4F4",
    d: "M122.381 74.775v1.042c0 .365.109.663.24.663h30.21c.131 0 .24-.298.24-.663v-1.042c0-.365-.109-.664-.24-.664h-30.21c-.131 0-.24.3-.24.664"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "l7vxaumg7d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xbp9m1ih3c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C8DBF4",
    d: "M132.012 115.854L159.025 115.854 159.025 76.481 132.012 76.481z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFEBFD",
    d: "M124.441 115.854L151.455 115.854 151.455 76.481 124.441 76.481z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7D3F3",
    d: "M126.153 113.42h23.59V77.853h-23.59v35.567zm-.26.26h24.11V77.594h-24.11v36.088z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7D3F3",
    d: "M126.023 89.791L149.873 89.791 149.873 89.531 126.023 89.531zM126.023 101.962L149.873 101.962 149.873 101.702 126.023 101.702zM135.504 79.92h4.426c.214 0 .39-.175.39-.39 0-.215-.176-.39-.39-.39h-4.426c-.215 0-.39.175-.39.39 0 .215.175.39.39.39M135.504 91.822h4.426c.214 0 .39-.176.39-.39 0-.215-.176-.391-.39-.391h-4.426c-.215 0-.39.176-.39.39 0 .215.175.391.39.391M135.504 104.229h4.426c.214 0 .39-.176.39-.39 0-.216-.176-.391-.39-.391h-4.426c-.215 0-.39.175-.39.39 0 .215.175.39.39.39",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4E96",
    d: "M1.535 49.44H87.13c.848 0 1.535-.687 1.535-1.535v-.96c0-.849-.687-1.536-1.535-1.536H1.535C.687 45.41 0 46.096 0 46.944v.961c0 .848.687 1.535 1.535 1.535",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4E96",
    d: "M2.616 115.836l-.048-.006c-.57-.07-.975-.58-.903-1.138l8.696-67.267 4.873.14-11.686 67.594c-.075.433-.486.732-.932.677M87.447 115.836l.048-.006c.571-.07.975-.58.903-1.138l-8.695-67.267-4.873.14 11.686 67.594c.075.433.486.732.931.677",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5453C",
    d: "M142.685 69.396L141.679 69.558 139.775 57.7 140.781 57.538z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M139.943 55.531L139.775 57.7 140.781 57.538z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5453C",
    d: "M149.487 70.533L148.485 70.347 150.679 58.539 151.681 58.725z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M151.566 56.554L150.679 58.539 151.681 58.725z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5453C",
    d: "M148.217 67.07L147.215 66.884 149.409 55.076 150.411 55.262z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCBAB",
    d: "M150.296 53.09L149.409 55.076 150.411 55.262z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED7D2B",
    d: "M143.547 74.111L151.573 74.111 151.573 62.544 143.547 62.544z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99746",
    d: "M139.534 74.111L147.56 74.111 147.56 62.544 139.534 62.544z",
    mask: "url(#l7vxaumg7d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB27D",
    d: "M55.698 43.351s-4.878-1.401-6.236-1.014c-.958.273-2.18 1.69-2.818 2.501-.186.237-.015.583.286.58.816-.009 2.136-.062 2.827-.425.652-.343 1.623.412 2.704.416.83.004 1.898-.002 1.898-.002l1.339-2.056z",
    mask: "url(#l7vxaumg7d)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsers);
export default __webpack_public_path__ + "static/media/no-users.fbb07536bd5596d4bb537303d7fac8da.svg";
export { ForwardRef as ReactComponent };